import Cookies from 'js-cookie'

function MainPageFooter() {
  function clearcookie() {
    window.localStorage.clear()
    window.sessionStorage.clear()
    Cookies.remove('token')
    Cookies.remove('basic_token')
    Cookies.remove('special_token')
    Cookies.remove('individual_token')
    alert('清除成功')
    window.location.reload()
  }

  return (
    <div id='footer' className='py-4'>
      Copyright © 2021 Center for Teaching and Learning Development. All Rights Reserved
      <br />
      國立臺灣大學教務處教學發展中心　版權所有
      <br />
      <div style={{ textAlign: 'right', paddingRight: '40px' }}>
        <small>
          <span
            role='button'
            tabIndex={0}
            onClick={clearcookie}
            onKeyDown={(e) => e.key === 'Enter' && clearcookie()}
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            清除異常狀態
          </span>
        </small>
        <small>
        &nbsp; ( V1.2.1 )
        </small>
      </div>
    </div>
  )
}

export default MainPageFooter
